// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// const firebaseConfig = {
//   apiKey: "AIzaSyAKBORqvwwoVPavQjWYRBsIiKsPpnAzMDI",
//   authDomain: "portfolio-3d62f.firebaseapp.com",
//   projectId: "portfolio-3d62f",
//   storageBucket: "portfolio-3d62f.appspot.com",
//   messagingSenderId: "174398431968",
//   appId: "1:174398431968:web:ba76399a67746f87776685",
//   measurementId: "G-J9L99MMQC0"
// };

// const app = initializeApp(firebaseConfig);
// export const db = getFirestore(app);
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyCeFktwrjNxxH9-iW92ZYA09aPTJhRrtYg",
  authDomain: "portfolio-583b1.firebaseapp.com",
  projectId: "portfolio-583b1",
  storageBucket: "portfolio-583b1.appspot.com",
  messagingSenderId: "815676420577",
  appId: "1:815676420577:web:35701f3e0aa607b49322a0",
  measurementId: "G-FBE2QSFVWQ"
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);